<template>
  <div>
    <el-card>
      <div style="display: flex">
        <div style="width: 50%">
          <el-row>
            <el-col v-if="isShow">
              <el-button :disabled="editFlag" size="small" type="warning" @click="stprEdit"
                >编辑</el-button
              >
              <!-- rfid_perm_status 判断 当前登录账号是否有权限 0 没有权限 -->
            </el-col>
            <el-col v-else>
              <el-button size="small" type="primary" @click="submit()">保存</el-button>
              <el-button size="small" @click="closeEdit">取消</el-button>
            </el-col>
          </el-row>
          <el-form ref="stprRef" :disabled="isShow" :model="prop" label-width="100px">
            <el-row>
              <el-col :md="12">
                <el-form-item
                  :rules="{ request: true, message: '请输入备料数量', trigger: 'blur' }"
                  label="备料数量："
                  prop="rfid_stpr_phr"
                  size="small"
                >
                  <el-input v-model="prop.rfid_stpr_phr" maxlength="9" show-word-limit @input="stprPhrInp">
                    <template slot="append">个</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="12">
                <el-form-item label="填卡人：" prop="card_user_id">
                  <el-select v-model="prop.card_user_id" filterable placeholder="请选择">
                    <el-option v-for="item in stffList" :key="item.user_id" :label="item.stff_name" :value="item.user_id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <el-form :disabled="isShow" label="right" label-width="100px">
            <el-row>
              <el-form-item label="制作人：" size="small">
                <el-select
                  v-model="prop.stff_id"
                  :disabled="!['徐礼明', '盖新', 'Admin'].includes($cookies.get('userInfo').stff_name)"
                  filterable
                  placeholder="请选择"
                  @change="
                    val => {
                      const find = processList.find(item => item.value === val).o;
                      prop.user_id = find.user_id;
                      prop.stff_name = find.stff_name;
                    }
                  "
                >
                  <el-option v-for="item in processList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="岗位：" size="small">
                <el-input :value="prop.user_jobs" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="难度系数：" size="small">
                <el-input :value="prop.price" disabled show-word-limit></el-input>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { post } from '@api/request';
import { spocAPI } from '@api/modules/spoc';

export default {
  data() {
    return {
      stprForm: {},
      isShow: true
    };
  },
  props: {
    prop: {
      type: Object
    },
    rfid_perm_status: Number,
    rfid_Info: Object,
    editFlag: Boolean,
    mainIsShow: Boolean,
    originalStpr: Object,
    stffList: Array,
    processList: Array
  },
  methods: {
    submit() {
      this.$confirm('此操作将保存修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          console.info('🚀 ~ file:SmplEditStprChild.vue time:18:09 line:108 -----', JSON.parse(JSON.stringify(this.prop)));

          let editBody = {};
          editBody = JSON.parse(JSON.stringify(this.prop));
          if (!editBody.rfid_id) {
            editBody.rfid_id = this.rfid_Info.rfid_id;
          }
          post(spocAPI.edit_stpr, editBody)
            .then(res => {
              if (res.data.code == 0) {
                this.$message.success(res.data.msg);
                this.$emit('copyStpr', this.prop);
                this.originalStpr.rfid_stpr_phr = this.prop.rfid_stpr_phr;
              } else {
                this.$message.error(res.data.msg);
              }
              this.$emit('del');
            })
            .catch(res => {
              this.$message.error(res.data.msg);
            });

          this.isShow = true;
        })
        .catch(res => {});
    },
    stprEdit() {
      this.$emit('num');
      this.isShow = false;
    },
    closeEdit() {
      this.$confirm('此操作将取消修改, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          this.isShow = true;
          this.$message.info('已取消修改');
          this.$emit('del');
          this.prop.rfid_stpr_phr = this.originalStpr.rfid_stpr_phr;
        })
        .catch(res => {});
    },
    stprPhrInp() {
      let val = this.helper.keepTNum(this.prop.rfid_stpr_phr);
      this.$emit('stprPhrInt', val);
    }
  },
  mounted() {
    this.$forceUpdate();
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
</style>
